import styled from '@emotion/styled'

import { breakpoints, container, palette, spacing } from 'main/ui'

export const Container = styled.div`
  background-color: ${palette.lightGray};
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: ${breakpoints.md}px) {
    margin-bottom: ${spacing.majorScale(8)}px;
  }
`

export const ContentMarginContainer = styled.div`
  margin: 0 ${spacing.majorScale(2)}px;
`

interface IProps {
  paddingBottom?: number
}

export const ContentContainer = styled.div<IProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${container.maxWidth.sm}px;
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : 0)}px;

  @media (min-width: ${breakpoints.lg}px) {
    max-width: ${container.maxWidth.lg}px;
  }
`

export const HeaderContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  justify-content: normal;
  margin-top: ${spacing.majorScale(4)}px;
  width: 100%;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(3)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    > :not(:last-child) {
      margin-bottom: 0;
    }
  }
`

export const Logo = styled.img`
  height: 20px;
`

export const BottomBar = styled.div`
  background-color: ${palette.skyBlue2};
  height: 10px;
  margin-top: ${spacing.majorScale(4)}px;
  width: 100%;
`
